// extracted by mini-css-extract-plugin
export default {"tabsContainer":"Tabs_tabsContainer__yW-zX"};